import util from '@bmp-vue/core/api/util'

const controller = 'User'
export default Object.assign({}, util.GetCrud(controller, null))
